<script setup lang="ts">
const repository = createProductSmartFiltersRepository()

const localePath = useLocalePath()
const route = useRoute()
const smartFilterSlug = computed(() => route.params.slug as string)

const { t } = useI18n()

const { data: smartFilter, status } = await useLazyAsyncData(() =>
  repository.getBySlug(smartFilterSlug.value)
)

if (smartFilter.value?.translationOfNid) {
  await useTranslatedSlugs(smartFilter.value?.translationOfNid)
}

watchEffect(async () => {
  if (status.value === 'error') {
    try {
      const translatedSlug = await repository.translateSlug(
        smartFilterSlug.value
      )
      if (translatedSlug) {
        await navigateTo(
          localePath({
            name: 'products-slug',
            params: { slug: translatedSlug.urlSlug },
          })
        )
      } else {
        throw createError({
          statusCode: 404,
          message: t('error.pageNotFound'),
          fatal: true,
        })
      }
    } catch {}
  }
})

const { defaultOgImage } = useOgImage()
const { trimDescription, addSuffix } = useMeta()

// definePageMeta({
//   scrollToTop: false,
// })

useSeoMeta({
  title:
    addSuffix(smartFilter.value?.title) ?? t('pages.product-lines.meta.title'),
  description:
    trimDescription(stripHtml(smartFilter.value?.description)) ??
    t('pages.index.meta.description'),
  ogImage: smartFilter.value?.image?.url ?? defaultOgImage,
})
</script>

<template>
  <main>
    <div v-if="status === 'pending'">
      <div class="container flex flex-col">
        <UiSkeletonSmartFiltersBanner class="mb-16" />
        <UiSkeletonFiltersPicker class="pb-16" />
      </div>
      <div class="bg-neutral-100">
        <UiSkeletonProductsGrid class="container pb-24 pt-16" />
      </div>
    </div>
    <div v-else>
      <ProductsFiltersSmartBanner :smart-filter="smartFilter" />
      <ProductsFilters :smart-filter="smartFilter" />
    </div>
  </main>
</template>
